import { defineComponent as _defineComponent } from 'vue'
interface Props {
  text: string
  side: 'left' | 'right'
}

export default /*#__PURE__*/_defineComponent({
  __name: 'InDmMessage',
  props: {
    text: null,
    side: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})